var _path, _path2, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "instagram-2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.795,
    height: 26.795,
    viewBox: "0 0 26.795 26.795",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3030",
    "data-name": "Path 3030",
    d: "M18.422,0H8.373A8.374,8.374,0,0,0,0,8.373V18.422a8.374,8.374,0,0,0,8.373,8.373H18.422a8.374,8.374,0,0,0,8.373-8.373V8.373A8.374,8.374,0,0,0,18.422,0Zm5.861,18.422a5.868,5.868,0,0,1-5.861,5.861H8.373a5.868,5.868,0,0,1-5.861-5.861V8.373A5.868,5.868,0,0,1,8.373,2.512H18.422a5.868,5.868,0,0,1,5.861,5.861Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3031",
    "data-name": "Path 3031",
    d: "M134.7,128a6.7,6.7,0,1,0,6.7,6.7A6.7,6.7,0,0,0,134.7,128Zm0,10.885a4.187,4.187,0,1,1,4.187-4.187A4.193,4.193,0,0,1,134.7,138.885Z",
    transform: "translate(-121.301 -121.301)",
    fill: "#fff"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_6",
    "data-name": "Ellipse 6",
    cx: 0.893,
    cy: 0.893,
    r: 0.893,
    transform: "translate(19.706 5.304)",
    fill: "#fff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.61c9dd4d16138c42bbd516af1e50116e.svg";
export { ForwardRef as ReactComponent };